import Vue from 'vue'
import App from './App'
import VueI18n from 'vue-i18n'
import VueResource from 'vue-resource'
// Router & Store
import router from './router.js'
import store from './store.js'
// Languages
import en from './assets/languages/en.json'
import ru from './assets/languages/ru.json'

Vue.config.productionTip = false;
Vue.use(VueResource);
Vue.use(VueI18n);

const bus = new Vue();
export default bus;

function getCookie(name) {
    var matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

const i18n = new VueI18n({
    locale: ((getCookie('language') || navigator.language || navigator.userLanguage ) === "ru" || ((navigator.language || navigator.userLanguage ) === "ru-RU")) ? "ru-RU" : "en-US",
    messages: {
        'en-US': en['messages'],
        'ru-RU': ru['messages']
    },
    dateTimeFormats: {
        'en-US': en['dateTimeFormats'],
        'ru-RU': ru['dateTimeFormats']
    }
})
Vue.http.options.root = API_URL;

Vue.mixin({
    methods: {
        checkLangField(field) {
            return (!!field && !!field[this.$i18n.locale])
        }
    }
})

const app = new Vue({
    el: '#app',
    router,
    store,
    i18n,
    template: '<App/>',
    components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js